module.exports = __webpack_public_path__ + "static/img/cangchubg.7bd1510.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cangchubg.jpg
// module id = xDWu
// module chunks = 1